<script>
import App from "@/pages/layouts/app.vue";
import {useForm, router} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import TwoFactor from "@/pages/profile/two-factor.vue";
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import Changes from "@wielink-application/shared/js/mixins/changes";
import FormElements from "@wielink-application/shared/js/mixins/formElements";

export default {
  mixins:[FormElements, UpdateForm, Changes],
  components: {App, Card, TwoFactor},
  props: ['twoFaEnabled', 'qrImage', 'secret'],

  data() {
    return {
      formRoute: route('profile.update'),
      form: useForm({
        'name': this.$page.props.auth.user.name,
        'email': this.$page.props.auth.user.email,
        'current_password': '',
        'password': '',
        'password_confirmation': '',
      })
    }
  },

  methods: {
    afterSuccess(form, response) {
      this.form.reset('current_password', 'password', 'password_confirmation');
    }
  }
}
</script>

<template>
  <App title="Mijn account">
    <form class="mb-4" @submit.prevent="submit" id="profile-form">
      <div class="row g-4">
        <div class="col-xl-6">
          <Card class="h-100">
            <h2 class="card-title">Profiel</h2>
            <p>Wijzig hier uw profiel en e-mailadres.</p>
            <Input v-model="form.name" :form="form" name="name" label="Naam" required/>
            <Email groupClasses="mb-0" v-model="form.email" :form="form" name="email" label="E-mail"  required/>
          </Card>
        </div>

        <div class="col-xl-6">
          <Card class="mb-4">
            <h2 class="card-title">Wachtwoord</h2>
            <p>Zorg voor een veilig wachtwoord</p>
            <Password v-model="form.current_password" :form="form" name="current_password" label="Huidig wachtwoord"/>
            <Password v-model="form.password" :form="form" name="password" label="Wachtwoord"/>
            <Password groupClasses="mb-0" v-model="form.password_confirmation" :form="form" name="password_confirmation" label="Herhaal wachtwoord"/>
          </Card>

          <Card>
            <TwoFactor :secret="secret" :qr-image="qrImage" :two-fa-enabled="twoFaEnabled" />
          </Card>
        </div>
      </div>
    </form>

    <template #bottomButtons>
      <div class="d-flex gap-2">
        <button form="profile-form" :class="{'btn btn-primary': true, 'loading': loading}" :disabled="loading">Opslaan</button>
      </div>
    </template>
  </App>
</template>